export default "__VITE_ASSET__060753aa__"